import { useEffect, useState, useContext } from "react"
import { useHistory } from "react-router-dom"
import { GlobalContext } from "@Context/context/GlobalContext"
import Logger from "@Classes/Logger"
import { executeShipingGroupAction } from "@Services/ShippingGroupService"
import { NOTIFY_CANCEL } from "@Helpers/constHelper"
import { TransactionCodeEnum } from "@Enums/TransactionCodeEnum"
import { EShippinggroupAction } from "@Enums/shippinggroupEmun"
import { IOrder } from "@Interfaces/IOrder"
import { TypeVariation6 } from "@Types/CommonsTypes"
import { ResourcePermissionsEnum } from "@Enums/ResourcePermissionsEnum"
import useUserPermissions from "@Hooks/UseUserPermissions"

const useCancelDecreaseOrder = ({
  order,
  shippingGroupId,
}: { order: IOrder | TypeVariation6, shippingGroupId: string } ) => {
  const { notification, errorHander } = useContext(GlobalContext)

  const [canIuseCancelDecraese, setCanIuseCancelDecraese] = useState(false);

  const [loadingCancelDecrase, setLoadingCancelDecrase] = useState(false)

  const history = useHistory()

  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.rejectOrderDecrease] });

  useEffect( () => {
    permission[ResourcePermissionsEnum.rejectOrderDecrease] && setCanIuseCancelDecraese(true) 
  }, [permission])

  const handleClickCancelDecreaseOrder = async (action: EShippinggroupAction) => {
    try {
      setLoadingCancelDecrase(true)
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action, 
      })

      setLoadingCancelDecrase(false)

      //picking success TODO:: case error
      if (code === TransactionCodeEnum.ok) {
        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Orden rechazada correctamente",
            title: NOTIFY_CANCEL,
            type: "success",
          },
        })

        setTimeout(() => history.push("/order/canceled"), 2000)
      }
    } catch (error: any) {
      Logger.error(error)
      setLoadingCancelDecrase(false)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    handleClickCancelDecreaseOrder,
    loadingCancelDecrase,
    canIuseCancelDecraese
  }
}

export default useCancelDecreaseOrder
